module.exports = __webpack_public_path__ + "static/media/medium-car.8c88a426.svg";